import React, { createContext, useState, useContext } from 'react';
import { debounce } from 'lodash';
import queryNpCoordinationItems from '../api/queryNpCoordinationItems';

const NpCoordinationContext = createContext();

export const NpCoordinationProvider = ({ children }) => {
  const [npCoordinationItems, setNpCoordinationItems] = useState([] );
  const [activePage, setActivePage] = useState(1)
  const [totalItemsCount, setTotalItemsCount] = useState(0)
  const [filters, setFilters] = useState({});
  const [shouldClearFilters, setShouldClearFilters] = useState(false);
  const [itemsLoading, setItemsLoading] = useState(false);

  const setFilter = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };

  const clearFilters = () => {
    setFilters({});
    setShouldClearFilters(true);
  };

  const resetClearFilters = () => {
    setShouldClearFilters(false);
  };

  const debouncedLoadItems = debounce(async (filters, activePage) => {
    setItemsLoading(true);
    try {
      const { items, page, totalCount } = await queryNpCoordinationItems(filters, activePage);
      setNpCoordinationItems(items);
      setTotalItemsCount(totalCount);
    } finally {
      setItemsLoading(false);
    }
  });

  return (
    <NpCoordinationContext.Provider
      value={{
        filters,
        setFilter,
        clearFilters,
        shouldClearFilters,
        resetClearFilters,
        activePage,
        setActivePage,
        itemsLoading,
        setItemsLoading,
        totalItemsCount,
        npCoordinationItems,
        debouncedLoadItems
      }}
    >
      {children}
    </NpCoordinationContext.Provider>
  );
};

export const useNpCoordination = () => {
  const context = useContext(NpCoordinationContext);
  if (!context) {
    throw new Error('useFilters must be used within a FiltersProvider');
  }
  return context;
};
